
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'generalInfo': 'Общие',
	'widgetId': 'ID виджета',
	'widgetType': 'Тип виджета',
	'serviceability': 'Удобство обслуживания',
	'copyButton': 'Копировать',
	'closeButton': 'Закрыть',
	'specification': 'Спецификация',
	'viewSpecification': 'Просмотреть спецификацию'
});
